{
  "kind": {
    "MINISTRY": "وزارة",
    "DG": "مديرية عامة",
    "DEPARTMENT": "دائرة",
    "SECTION": "قسم",
    "DIVISION": "شعبة",
    "BRANCH": "فرع",
    "OTHER": "أخرى"
  },
  "archived": "مؤرشفة",
  "acting": "بالإنابة",
  "vacant": "شاغر",
  "tree": {
    "label": "الهيكل التنظيمي",
    "search": "ابحث عن وحدة بالرمز أو الاسم…",
    "clearSearch": "مسح البحث",
    "showArchived": "إظهار الوحدات المؤرشفة",
    "expandAll": "توسيع الكل",
    "collapseAll": "طي الكل",
    "unit": "الوحدة",
    "kind": "النوع",
    "head": "الرئيس",
    "actions": "الإجراءات",
    "noMatch": "لا توجد وحدة تطابق «{{query}}».",
    "empty": {
      "title": "لا توجد وحدات بعد",
      "body": "ابدأ بأعلى الهيكل (الوزارة أو الشركة)، ثم أضف تحتها المديريات والدوائر والأقسام."
    }
  },
  "actions": {
    "new": "وحدة جديدة",
    "addChild": "إضافة وحدة فرعية إلى {{name}}",
    "edit": "تعديل {{name}}",
    "archive": "أرشفة {{name}}",
    "restore": "استعادة {{name}}",
    "open": "فتح {{name}}",
    "editShort": "تعديل",
    "addChildShort": "إضافة وحدة فرعية",
    "move": "نقل",
    "archiveShort": "أرشفة",
    "restoreShort": "استعادة",
    "import": "استيراد…"
  },
  "fields": {
    "code": "الرمز",
    "name": "الاسم",
    "nameAr": "الاسم بالعربية",
    "kind": "النوع",
    "parent": "الوحدة الأم",
    "head": "الرئيس",
    "actingHead": "الرئيس بالإنابة",
    "actingFrom": "الإنابة من",
    "actingTo": "الإنابة حتى",
    "hrbp": "شريك الموارد البشرية",
    "defaultWorkLocation": "موقع العمل الافتراضي",
    "costCentreRef": "مرجع مركز التكلفة"
  },
  "form": {
    "newTitle": "وحدة تنظيمية جديدة",
    "newBody": "وزارة أو مديرية أو دائرة أو قسم أو فرع في الهيكل التنظيمي.",
    "editTitle": "تعديل الوحدة التنظيمية",
    "create": "إنشاء الوحدة",
    "people": "الأشخاص",
    "actingPeriod": "الرئيس بالإنابة (اختياري)",
    "actingBody": "أثناء غياب الرئيس، تذهب الموافقات إلى الرئيس بالإنابة خلال هذه الفترة.",
    "hints": {
      "code": "قصير ودائم: لا يمكن تغييره لاحقًا.",
      "parent": "اتركه فارغًا لوحدة في أعلى الهيكل. لتغييره لاحقًا استخدم «نقل».",
      "actingTo": "اتركه فارغًا حتى إشعار آخر."
    },
    "noParent": "أعلى الهيكل",
    "noPerson": "لا أحد",
    "choosePerson": "اختر شخصًا",
    "searchPeople": "ابحث بالاسم أو البريد الإلكتروني…",
    "noPeople": "لا يوجد من يطابق البحث",
    "peopleError": "تعذّر تحميل الأشخاص.",
    "noLocation": "لا يوجد",
    "errors": {
      "code": "أدخل الرمز",
      "codeFormat": "استخدم حروفًا لاتينية أو أرقامًا أو نقاطًا أو شرطات",
      "codeTaken": "هذا الرمز مستخدم لوحدة أخرى",
      "name": "أدخل اسم الوحدة",
      "actingHead": "اختر الرئيس بالإنابة",
      "actingFrom": "أدخل بداية فترة الإنابة",
      "actingTo": "لا يمكن أن تسبق النهاية البداية",
      "person": "لم يعد هذا الشخص نشطًا. اختر شخصًا نشطًا",
      "location": "موقع العمل هذا مؤرشف. اختر موقعًا نشطًا"
    }
  },
  "detail": {
    "title": "وحدة تنظيمية",
    "path": "تتبع",
    "topLevel": "وحدة في أعلى الهيكل",
    "head": "الرئيس",
    "actingHead": "الرئيس بالإنابة",
    "actingFrom": "من {{from}} حتى إشعار آخر",
    "actingRange": "من {{from}} إلى {{to}}",
    "hrbp": "شريك الموارد البشرية",
    "location": "موقع العمل الافتراضي",
    "costCentre": "مرجع مركز التكلفة",
    "subunits": "الوحدات الفرعية",
    "members": "الأعضاء ({{n}})",
    "membersHint": "الأشخاص الذين هذه وحدتهم الأساسية (دون وحداتها الفرعية).",
    "noMembers": "لا أحد وحدته الأساسية هذه الوحدة بعد.",
    "membersHidden": "عرض الأعضاء يتطلب صلاحية عرض المستخدمين.",
    "none": "—"
  },
  "move": {
    "title": "نقل {{name}}",
    "body": "تنتقل الوحدة مع جميع وحداتها الفرعية وأعضائها. ومسارات الموافقة تتبع موقعها الجديد في الهيكل.",
    "newParent": "الوحدة الأم الجديدة",
    "confirm": "نقل الوحدة"
  },
  "archive": {
    "title": "أرشفة {{name}}؟",
    "body": "الوحدة المؤرشفة لا تقبل أعضاء أو سجلات جديدة، والسجلات التي تذكرها تحتفظ بها. يمكنك استعادتها لاحقًا.",
    "confirm": "أرشفة الوحدة",
    "restoreTitle": "استعادة {{name}}؟",
    "restoreBody": "ستقبل الوحدة الأعضاء والسجلات من جديد.",
    "restoreConfirm": "استعادة الوحدة"
  },
  "import": {
    "title": "استيراد الوحدات من ملف CSV",
    "description": "تُطابَق الوحدات بالرمز. تُنشأ الرموز الجديدة، وتُعاد تسمية الوحدات القائمة أو تُنقل أو تُؤرشف أو تُستعاد لتطابق الملف. الوحدات غير الموجودة في الملف تبقى كما هي.",
    "choose": "اختر ملف CSV",
    "chooseAnother": "اختر ملفًا آخر",
    "file": "ملف CSV للوحدات التنظيمية",
    "template": "تنزيل القالب",
    "columns": "الأعمدة: code وname وname_ar وkind وparent_code وstatus. النوع أحد القيم {{kinds}}. اترك parent_code فارغًا للوحدة العليا؛ ولا تُؤرشف الوحدة إلا بالحالة ARCHIVED.",
    "previewing": "جارٍ فحص الملف…",
    "summary": "ما سيغيّره الاستيراد",
    "counts": {
      "create": "جديدة",
      "rename": "أُعيدت تسميتها",
      "move": "نُقلت",
      "archive": "أُرشفت",
      "restore": "استُعيدت",
      "unchanged": "دون تغيير",
      "error": "بها أخطاء"
    },
    "fileErrors": "تعذّرت قراءة الملف",
    "fixErrors": "صحّح الصفوف المعلّمة بالأحمر في الملف ثم اختره مجددًا. لا يُستورد شيء ما دامت هناك أخطاء.",
    "nothing": "الهيكل التنظيمي يطابق هذا الملف بالفعل: لا شيء للاستيراد.",
    "rows": "الصفوف التي تغيّر شيئًا أو بها أخطاء",
    "line": "السطر",
    "change": "التغيير",
    "details": "التفاصيل",
    "under": "تحت",
    "action": {
      "CREATE": "جديدة",
      "ERROR": "خطأ"
    },
    "change_": {
      "RENAME": "إعادة تسمية",
      "KIND": "تغيير النوع",
      "MOVE": "نقل",
      "ARCHIVE": "أرشفة",
      "RESTORE": "استعادة"
    },
    "applyShort": "استيراد",
    "apply_zero": "استيراد {{n}} تغيير",
    "apply_one": "استيراد تغيير واحد",
    "apply_two": "استيراد تغييرين",
    "apply_few": "استيراد {{n}} تغييرات",
    "apply_many": "استيراد {{n}} تغييرًا",
    "apply_other": "استيراد {{n}} تغيير",
    "applied_zero": "لم تُستورد أي وحدة",
    "applied_one": "استُوردت وحدة واحدة",
    "applied_two": "استُوردت وحدتان",
    "applied_few": "استُوردت {{n}} وحدات",
    "applied_many": "استُوردت {{n}} وحدة",
    "applied_other": "استُوردت {{n}} وحدة",
    "staleTitle": "تغيّر الهيكل التنظيمي منذ المعاينة",
    "staleBody": "غيّر أحدهم الوحدات، أو أن الملف مختلف. عاين الملف مجددًا لترى ما سيفعله الاستيراد الآن.",
    "previewAgain": "معاينة مجددًا",
    "becomes": "تصبح",
    "fieldError": "{{field}}: {{message}}",
    "column": {
      "code": "الرمز (code)",
      "name": "الاسم (name)",
      "name_ar": "الاسم بالعربية (name_ar)",
      "kind": "النوع (kind)",
      "parent_code": "الوحدة الأم (parent_code)",
      "status": "الحالة (status)"
    },
    "errors": {
      "CSV_PARSE": "تعذّرت قراءة السطر {{line}} بصيغة CSV (تحقق من علامات الاقتباس والفواصل).",
      "FILE_EMPTY": "الملف فارغ.",
      "UNKNOWN_COLUMN": "عمود غير معروف «{{column}}».",
      "DUPLICATE_COLUMN": "العمود «{{column}}» مكرر.",
      "MISSING_COLUMN": "العمود «{{column}}» مفقود.",
      "TOO_MANY_ROWS": "يحتوي الملف على أكثر من {{max}} وحدة.",
      "CODE_INVALID": "أدخل رمزًا من 30 حرفًا لاتينيًا أو رقمًا أو نقطة أو شرطة كحد أقصى.",
      "CODE_DUPLICATE": "هذا الرمز مكرر في الملف.",
      "TOO_MANY_FIELDS": "يحتوي الصف على حقول أكثر من الترويسة.",
      "NAME_REQUIRED": "الاسم مطلوب.",
      "TOO_LONG": "{{max}} حرفًا كحد أقصى.",
      "BAD_KIND": "استخدم إحدى القيم {{kinds}}.",
      "BAD_STATUS": "استخدم ACTIVE أو ARCHIVED.",
      "PARENT_UNKNOWN": "الوحدة الأم غير معروفة.",
      "CYCLE": "لا يمكن وضع وحدة تحت نفسها أو تحت إحدى وحداتها الفرعية.",
      "PARENT_ARCHIVED": "لا يمكن أن تكون وحدة نشطة تحت وحدة مؤرشفة.",
      "ARCHIVED_LOCKED": "لا يمكن تغيير وحدة مؤرشفة؛ استعدها أولًا.",
      "HAS_CHILDREN": "لا تزال لها وحدات فرعية نشطة ({{n}})."
    }
  },
  "toast": {
    "created": "أُنشئت الوحدة {{name}}",
    "saved": "حُفظت الوحدة {{name}}",
    "moved": "نُقلت الوحدة {{name}}",
    "archived": "أُرشفت الوحدة {{name}}",
    "restored": "استُعيدت الوحدة {{name}}"
  },
  "errors": {
    "ORG_UNIT_CYCLE": "لا يمكن نقل وحدة تحت نفسها أو تحت إحدى وحداتها الفرعية.",
    "SCOPE_RESTRICTED": "لا يمكن تعديل الهيكل التنظيمي إلا لمستخدم تشمل صلاحياته جميع السجلات.",
    "ORG_UNIT_HAS_CHILDREN": "ما زالت لها وحدات فرعية نشطة ({{n}}). انقلها أو أرشفها أولًا.",
    "ORG_UNIT_HAS_MEMBERS": "ما زالت الوحدة الأساسية لمستخدمين نشطين ({{n}}). انقلهم إلى وحدة أخرى أولًا.",
    "ORG_UNIT_HAS_SCOPED_GRANTS": "ما زالت إسنادات أدوار مقيدة بهذه الوحدة ({{n}}). غيّر نطاقها أولًا.",
    "ORG_UNIT_PARENT_ARCHIVED": "الوحدة الأم مؤرشفة. استعدها أو اختر وحدة أمًّا أخرى أولًا.",
    "ORG_UNIT_ARCHIVED": "هذه الوحدة مؤرشفة. استعدها قبل تعديلها.",
    "ORG_UNIT_NOT_FOUND": "هذه الوحدة لم تعد موجودة.",
    "WORK_LOCATION_IN_USE": "وحدات نشطة تستخدم هذا الموقع موقعًا افتراضيًا ({{n}}). غيّرها أولًا.",
    "WORK_LOCATION_ARCHIVED": "موقع العمل هذا مؤرشف. استعده قبل تعديله."
  },
  "picker": {
    "placeholder": "اختر وحدة",
    "search": "ابحث عن وحدة…",
    "empty": "لا توجد وحدة مطابقة",
    "none": "بلا وحدة",
    "archived": "مؤرشفة"
  },
  "locations": {
    "listLabel": "مواقع العمل",
    "views": "عروض مواقع العمل",
    "active": "النشطة",
    "archived": "المؤرشفة",
    "new": "موقع عمل جديد",
    "newTitle": "موقع عمل جديد",
    "newBody": "مكتب أو موقع أو مبنى يعمل فيه الموظفون. يمكن للوحدات اعتماده موقعًا افتراضيًا.",
    "editTitle": "تعديل موقع العمل",
    "create": "إنشاء الموقع",
    "edit": "تعديل {{name}}",
    "archive": "أرشفة {{name}}",
    "restore": "استعادة {{name}}",
    "fields": {
      "code": "الرمز",
      "name": "الاسم",
      "nameAr": "الاسم بالعربية",
      "governorate": "المحافظة",
      "wilayat": "الولاية",
      "address": "العنوان",
      "latitude": "خط العرض",
      "longitude": "خط الطول"
    },
    "hints": {
      "code": "قصير ودائم: لا يمكن تغييره لاحقًا.",
      "wilayat": "اختر المحافظة أولًا.",
      "coordinates": "اختياري. كلاهما أو لا شيء، بالدرجات العشرية (مثل 23.588، 58.3829)."
    },
    "noGovernorate": "غير محددة",
    "noWilayat": "غير محددة",
    "coordinates": "الإحداثيات",
    "empty": {
      "title": "لا توجد مواقع عمل بعد",
      "body": "أضف المكاتب والمواقع التي يعمل فيها الموظفون، حسب المحافظة والولاية.",
      "archived": "لا توجد مواقع عمل مؤرشفة."
    },
    "errors": {
      "code": "أدخل الرمز",
      "codeFormat": "استخدم حروفًا لاتينية أو أرقامًا أو نقاطًا أو شرطات",
      "codeTaken": "هذا الرمز مستخدم لموقع عمل آخر",
      "name": "أدخل اسم الموقع",
      "coordinates": "أدخل خط العرض وخط الطول معًا، أو اتركهما",
      "latitude": "خط العرض رقم بين ‎-90 و90",
      "longitude": "خط الطول رقم بين ‎-180 و180"
    },
    "archiveDialog": {
      "title": "أرشفة {{name}}؟",
      "body": "لا تُعرض المواقع المؤرشفة على الوحدات. يمكنك استعادته لاحقًا.",
      "confirm": "أرشفة الموقع",
      "restoreTitle": "استعادة {{name}}؟",
      "restoreBody": "سيُعرض الموقع على الوحدات من جديد.",
      "restoreConfirm": "استعادة الموقع"
    },
    "toast": {
      "created": "أُنشئ موقع العمل {{name}}",
      "saved": "حُفظ موقع العمل {{name}}",
      "archived": "أُرشف موقع العمل {{name}}",
      "restored": "استُعيد موقع العمل {{name}}"
    }
  },
  "homeUnit": {
    "label": "الوحدة الأساسية",
    "none": "بلا وحدة أساسية",
    "change": "تغيير",
    "changeNamed": "تغيير الوحدة الأساسية لـ{{name}}",
    "title": "الوحدة الأساسية لـ{{name}}",
    "body": "الوحدة التي يتبعها المستخدم. تبدأ مشترياته فيها، والموافقات الموجهة إلى «رئيس وحدة مقدم الطلب» تتبعها.",
    "field": "الوحدة الأساسية",
    "clear": "بلا وحدة أساسية",
    "save": "حفظ الوحدة الأساسية",
    "saved": "حُفظت الوحدة الأساسية لـ{{name}}",
    "column": "الوحدة",
    "filter": "الوحدة",
    "allUnits": "كل الوحدات"
  }
}
